import React from "react";
import {useTranslation} from "react-i18next";
import styles from "../../../../../../assets/main/Dashboards/TracingTopology.module.scss";
import {RISK_COLORS, ROOT_BG} from "../../../../../../util/graph/options";

const LegendBox = props => {
    const {t} = useTranslation();
    return <div className={`${styles["legend-box-wrapper"]} graph-name-label-custom`} style={{left: "15px"}}>
        <div className={styles["legend-box"]}>
            <dl>
                <dd>
                    <i className="fas fa-map-marked-alt" style={{color: ROOT_BG}} /><span>{t("Space")}</span>
                </dd>
                <dd>
                    <i className="fas fa-user-circle" style={{color: RISK_COLORS.critical}} /><span>{t("Critical")}</span>
                </dd>
                <dd>
                    <i className="fas fa-user-circle" style={{color: RISK_COLORS.warning}} /><span>{t("Warning")}</span>
                </dd>
                <dd>
                    <i className="fas fa-user-circle" style={{color: RISK_COLORS.caution}} /><span>{t("Caution")}</span>
                </dd>
            </dl>
        </div>
    </div>
}

export default LegendBox;